type SelectProps = {
  value?: string | number;
  onChange?: (value: string | number) => void;
  options: { label: string; value: string | number }[];
};

export const Select: React.FC<SelectProps> = ({ value, onChange, options }) => {
  return (
    <select
      value={value}
      onChange={(e) => onChange && onChange(e.target.value)}
      className="h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"
    >
      {options.map((op) => (
        <option value={op.value} key={op.value}>
          {op.label}
        </option>
      ))}
    </select>
  );
};
